import { cssRule } from 'typestyle';

cssRule('.tb-box', {
    display: 'inline-block',
    verticalAlign: 'top',
});

cssRule('.tb-row-height-box', {
    display: 'inline-block',
    verticalAlign: 'top',
    height: '23px',
    lineHeight: '23px',
});

cssRule('.tb-padded-box', {
    display: 'inline-block',
    verticalAlign: 'top',
    padding: '6px',
});

cssRule('.tb-padded', {
    padding: '6px',
});

cssRule('.tb-padded-wide', {
    padding: '12px',
});

cssRule('.tb-padded-small', {
    padding: '3px',
});

cssRule('.tb-padded-top-large', {
    paddingTop: '18px',
});

cssRule('.tb-padded-left', {
    paddingLeft: '6px',
});

cssRule('.tb-padded-left-large', {
    paddingLeft: '18px',
});

cssRule('.tb-padded-right', {
    paddingRight: '6px',
});

cssRule('.tb-padded-right-large', {
    paddingRight: '12px',
});

cssRule('.tb-padded-bottom', {
    paddingBottom: '6px',
});

cssRule('.tb-padded-top-bottom', {
    padding: '6px 0px',
});

cssRule('.tb-padded-bottom-medium', {
    paddingBottom: '12px',
});

cssRule('.tb-lr-padded', {
    paddingLeft: '6px',
    paddingRight: '6px',
});

cssRule('.tb-lr-padded-narrow', {
    paddingLeft: '3px',
    paddingRight: '3px',
});

cssRule('.tb-lr-padded-wide', {
    paddingLeft: '12px',
    paddingRight: '12px',
});

cssRule('.tb-cell-height-padding', {
    paddingTop: '7px',
    paddingBottom: '7px',
});

cssRule('.tb-section', {
    marginTop: '26px',
});

cssRule('.tb-row', {
    marginTop: '6px',
});

cssRule('.tb-margin-left-wide', {
    marginLeft: '12px',
});

cssRule('.tb-margin-left-xlarge', {
    marginLeft: '35px',
});

cssRule('.tb-margin-top-bottom', {
    marginTop: '6px',
    marginBottom: '6px',
});

cssRule('.tb-margin-top-wide', {
    marginTop: '12px',
});

cssRule('.tb-margin-bottom-wide', {
    marginBottom: '12px',
});

cssRule('.tb-margin-right', {
    marginRight: '6px',
});

cssRule('.tb-margin-right-wide', {
    marginRight: '12px',
});

cssRule('.tb-margin-small', {
    margin: '3px',
});

cssRule('.tb-margin-top-small', {
    marginTop: '3px',
});

cssRule('.tb-margin-bottom-small', {
    marginBottom: '3px',
});

cssRule('.tb-margin-top-bottom-small', {
    marginTop: '3px',
    marginBottom: '3px',
});

cssRule('.tb-half-width', {
    width: '50%',
});

cssRule('.tb-full-width', {
    width: '100%',
});

cssRule('.tb-full-height', {
    height: '100%',
});

cssRule('.tb-border-box', {
    boxSizing: 'border-box',
});

